import { render, staticRenderFns } from "./HacizTalepList.vue?vue&type=template&id=7351feba&scoped=true"
import script from "./HacizTalepList.vue?vue&type=script&lang=ts"
export * from "./HacizTalepList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7351feba",
  null
  
)

export default component.exports